/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ExpiringPointSummaryDto } from '../models/ExpiringPointSummaryDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PointLotService {
  /**
   * 내 소멸 예정 포인트 조회
   * 이번 달 말일까지 소멸 예정인 포인트 합계를 조회합니다.
   * @returns ExpiringPointSummaryDto
   * @throws ApiError
   */
  public static pointLotControllerGetExpiringPointSummary(): CancelablePromise<ExpiringPointSummaryDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/users/me/point-lots/expiring',
    });
  }
}
